<template>
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>展品</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">展品</div>
        <div style="display: flex; align-items: end">
          <Select v-model="searchType" style="width: 100px">
            <Option v-for="item in cityList" :value="item.value" :key="item.value">{{
              item.label
            }}</Option>
          </Select>
          <Input
            search
            placeholder="请输入关键字"
            v-model="searchField"
            @on-search="searchPro()"
            style="width: 230px; margin-top: 20px"
          />
        </div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="downloadSearchEnd">
          <i class="icon iconfont icon-downLoad2"></i>
          <span>导出搜索结果</span>
        </div>
        <div class="htb-item" @click="$router.push('/host/index/pro/pro-export')">
          <i class="icon iconfont icon-downLoad2"></i>
          <span>导出展品</span>
        </div>
      </div>
    </div>
    <hostProductItem ref="hostProductItem" :searchField="searchField"  :searchType="searchType"  />
  </div>
</template>

<script>
import hostProductItem from "../components/host-product-item.vue";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "host-product",
  data() {
    return {
      company: null,
      editId: "",
      addBrandflag: false,
      showTabs: "1",
      searchField: "", // 搜索关键字
      cityList: [
        {
          value: "Name",
          label: "产品名",
        },
        {
          value: "TagName",
          label: "展品标签",
        },
        {
          value: "xinPin",
          label: "新品荟",
        },
        {
          value: "zhenPin",
          label: "臻品荟",
        },
      ],
      searchType: "Name",
    };
  },
  components: {
    hostProductItem,
  },
  async created() {
    let query = this.$route.query;
    if (query && query.id) {
      this.editId = query.id;
      let proData = await this.getCompanyByJoin(this.option);
      if (proData) {
        proData.items.map((c) => {
          if (c.categories) {
            c.categories = JSON.parse(c.categories);
          } else {
            c.categories = [];
          }
          if (c.boothInfo) {
            c.boothInfo = JSON.parse(c.boothInfo);
          } else {
            c.boothInfo = [];
          }
        });
        this.company = proData.items[0];
      }
    }
  },
  computed: {
    ...mapGetters({
      list: "productModule/list",
      pageInfo: "productModule/pageInfo",
      current: "productModule/current",
    }),

    query() {
      return this.$route.query;
    },
    option() {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "compId",
                  Value: `%${this.editId}%`,
                },
              },
            ],
          },
        },
      };
    },
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  methods: {
    ...mapMutations({
      refushPageInfo: "productModule/refushPageInfo",
      refushWheres: "productModule/refushWheres",
      refushCurrent: "productModule/refushCurrent",
    }),
    ...mapActions({
      getCompanyByJoin: "hostSetModule/getCompanyByJoin",
      getList: "productModule/getList",
      addProduct: "productModule/addProduct",
      add: "productModule/add",
      edit: "productModule/edit",
      getOne: "productModule/getOne",
      remove: "productModule/remove",
       addTask: "hostCommonModule/addTask",

    }),
    searchPro() {
      this.$refs.hostProductItem.reload();
    },
    downloadList() {
      this.$refs.exhibitionProductApply.exportInfo();
    },
      async downloadSearchEnd () {
        let textExport="产品表格搜索结果和图片导出"
        let dataVal={}
        if(this.searchType=='Name'){
            dataVal= {Name:this.searchField}
        }
        if(this.searchType=='TagName'){
            dataVal= {TagName:this.searchField}
        }
        if(this.searchType=='xinPin'){
            dataVal= {Name:this.searchField,TagId:"FCB459D0-9565-413B-832D-F25BBA4C3567"}
            textExport='新品荟产品表格搜索结果和图片导出'
        }
        if(this.searchType=='zhenPin'){
            dataVal= {Name:this.searchField,TagId :"45866A37-7712-4177-8F77-0183D1357578"}
            textExport='臻品荟产品表格搜索结果和图片导出'
        }
        
      let req = {
        "taskType": 0,
        "taskName": this.exhibitionInfo.name + textExport,
        "exhibitionId": this.exhibitionInfo.id,
        'searchCondition':JSON.stringify(dataVal)
      }
      let bool = await this.addTask(req);
      if (bool && bool.successed) {
        this.$Message.success("创建成功！");
        this.$router.push('/host/index/pro/pro-export')
      } else {
        this.$Message.success("创建失败，请重新尝试");
      }
    }
  },
};
</script>

<style scoped lang="scss">
.eb-top-r {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;
  &-box {
    width: 148px;
    height: 78px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      border: 1px dashed #1890ff;
      transition: 0.5s;
    }
    .I1 {
      font-size: 16px;
      font-weight: bold;
      color: #1890ff;
    }
    .s3 {
      font-size: 14px;
      color: #1890ff;
      margin-left: 9px;
    }
  }
}
</style>
